import React, { useContext, useEffect, useState } from 'react';
import { Col, FormContext, FormInput, FormSelect, FormTextArea, Icon } from '@digital/ui';
import * as Yup from 'yup';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import { getContratoDemandaInfo } from '@app/api/contrato';
import { caracteristicaContratacaoOptions, getPcsDemandaInfo } from '@app/api/demanda';
import { Row, Tooltip } from 'antd';
import { getAllGestoresOptions, verificarSeUsuarioAdministradorContrato } from '@app/api/usuario';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { Visibility } from '@app/components';
import { getAllPlanilhaQuantidadeMultiplosGestoresByContrato, getAllPlanilhaQuantidadeMultiplosGestoresByNumeroContrato } from '@app/api/contrato/planilhaQuantidadeContrato';
import { optionsSwitch } from '@app/helpers/optionsSwitch';

function IdentificacaoAdtivo() {
  const {
    statusCodigo,
    numeroContrato,
    setNumeroContrato,
    numeroPedido,
    setNumeroPedido,
    gestorTecnicoId,
    setGestorTecnicoId,
    tipoContrato,
    demandaData,
    setIdentificadorPQ,
    identificadorPQ,
    caracteristicaContratacao, setCaracteristicaContratacao
  } = useContext(QuestionarioContextProvider);
  const { formProps } = useContext(FormContext);
  const [timer, setTimer] = useState<number | null>(null);
  const [timerPQ, setTimerPQ] = useState<number | null>(null);
  const [contrato, setContrato] = useState<any>({});
  const [usuarioAdmContrato, setUsuarioAdmContrato] = useState(false);
  const disableGestor = tipoContrato === 'contrato' || statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante;
  const [inputIdentificadorPQ, setInputIdentificadorPQ] = useState(false)
  const [pqOptions, setPqOptions] = useState<{
          text: string,
          value: string
      }[]>();
  useEffect(() => {
    if (numeroContrato) {
      onChangeContrato(numeroContrato.toString());
    }
    if (numeroPedido) {
      onChangePedido(numeroPedido.toString());
    }
    verificarSeUsuarioAdministradorContrato().then(data => {
      if (data) {
        setUsuarioAdmContrato(data);
      }
    });
  }, []);

  useEffect(() => {
    setContrato({
      diretoria: demandaData.diretoriaTexto,
      area: demandaData.areaTexto,
      departamento: demandaData.departamentoTexto,
      gestorTecnicoId: demandaData.gestorTecnicoId,
    });
  }, [demandaData]);

  useEffect(() => {
    if (demandaData === undefined) return () => { };

    if (tipoContrato === 'contrato') {
      if (contrato.gestorTecnicoId) {
        if (demandaData.gestorTecnicoId && statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante) {
          setGestorTecnicoId(demandaData.gestorTecnicoId);
        } else {
          setGestorTecnicoId(contrato.gestorTecnicoId);
        }
      }
    }

    return () => { };
  }, [contrato]);

  const onChangeContrato = (change: string) => {
    if (formProps) {
      formProps.setFieldValue('numeroPedido', undefined);
      setNumeroPedido('');
      setIdentificadorPQ('')
    }
    setNumeroContrato(change);
    if (change.length > 0)
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
    setTimer(
      setTimeout(() => {
        setNumeroContrato(change);
        if (change.length == 4 && tipoContrato === 'contrato')
          getContratoDemandaInfo(change, demandaData.id).then(data => {
            if (data.isMultiplosGestores) {
              setInputIdentificadorPQ(true)
              setContrato({
                numeroFornecedor: data.numeroFornecedor,
                nomeFornecedor: data.nomeFornecedor,
                isMultiplosGestores: true
              })
            } else {
              setInputIdentificadorPQ(false)
              setContrato(data.invalid ? {} : data)
            }
          });
        else if (change.length == 6 && tipoContrato === 'pcs') {
          getPcsDemandaInfo(change).then(data => setContrato(data ? data : {}));
        } else setContrato({});
      }, 1000),
    );
  };

  const onChangePedido = (change: string) => {
    setNumeroPedido(change);
    if (formProps) {
      formProps.setFieldValue('numeroContrato', undefined);
      setNumeroContrato('');
    }
    if (change.length > 0)
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
    setTimer(
      setTimeout(() => {
        setNumeroPedido(change);
        if (change.length == 6) {
          getPcsDemandaInfo(change).then(data => setContrato(data ? data : {}));
        } else setContrato({});
      }, 1000),
    );
  };

  useEffect(() => {
    if (demandaData && inputIdentificadorPQ && numeroContrato && contrato.isMultiplosGestores) {
      if (timerPQ) {
        clearTimeout(timerPQ);
        setTimerPQ(null);
      }
    setTimerPQ(
      setTimeout(() => {
                getAllPlanilhaQuantidadeMultiplosGestoresByNumeroContrato(numeroContrato).then((data: any) => {
                    if (data) {
                        setPqOptions(data.map((item: any) => {
                            return {
                                text: `PQ ${item.identificador} - ${item.escopo}`,
                                value: item.id
                            }
                        }))
                    }
                })}, 1000),
    );
    }
  },[inputIdentificadorPQ, numeroContrato, contrato.isMultiplosGestores])


  const onChangePq = (change: string) => {
    if (formProps) {
      formProps.setFieldValue('numeroPedido', undefined);
      setNumeroPedido('');
    }
    setIdentificadorPQ(change);
    if (change)
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
    setTimer(
      setTimeout(() => {
        setIdentificadorPQ(change);
        if (change)
          getContratoDemandaInfo(numeroContrato, demandaData.id, change).then(data => {
              setContrato(data ? data : {})
          });
      }, 1000),
    );
  };

  return (
    <>
      <Row>
        {tipoContrato === 'contrato' && (
          <FormInput
            label="Número do Contrato"
            name="numeroContrato"
            id='mrn-input-numeroContrato'
            span={4}
            disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
            onChange={e => {
              onChangeContrato(e.currentTarget.value);
            }}
            maxLength={4}
            minLength={4}
            required
          />
        )}
        {tipoContrato === 'pcs' && formProps && (
          <>
            <FormInput
              label="Número do Contrato"
              name="numeroContrato"
              id='mrn-input-numeroContrato'
              span={2}
              disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
              onChange={e => {
                onChangeContrato(e.currentTarget.value);
              }}
              maxLength={6}
              validateSchema={Yup.string().when('numeroPedido', numeroPedido => {
                if (formProps.values.numeroPedido === undefined || formProps.values.numeroPedido === '') {
                  return Yup.string()
                    .required('Campo obrigatório.')
                    .length(6, 'O Número do Contrato deve conter 6 dígitos')
                    .matches(/^(8)[0-9]*/gm, {
                      message: 'O Número do Contrato deve começar com o dígito 8.',
                    });
                }
              })}
            />
            <FormInput
              label="Número do Pedido"
              name="numeroPedido"
              id='mrn-input-numeroPedido'
              span={2}
              disabled={statusCodigo === 7 || statusCodigo === 9 || statusCodigo === 2 || statusCodigo === 6}
              onChange={e => {
                onChangePedido(e.currentTarget.value);
              }}
              maxLength={6}
              validateSchema={Yup.string().when('numeroContrato', numeroContrato => {
                if (formProps.values.numeroContrato === undefined || formProps.values.numeroContrato === '')
                  return Yup.string()
                    .required('Campo obrigatório.')
                    .length(6, 'O Número do Pedido deve conter 6 dígitos')
                    .matches(/^(?!8)[0-9]*/gm, {
                      message: 'O Número do Pedido deve começar com o dígito diferente de 8.',
                    });
              })}
            />
          </>
        )}
        {inputIdentificadorPQ && <>
       
        <FormSelect
            label="Numero PQ"
            name="identificadorpq"
            id='pq-select-identificador'
            value={identificadorPQ}
            options={pqOptions}
            span={2}
            showSearch
            onSelect={(e:string) => onChangePq(e)}
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
            }}
            required
            validationSchema={Yup.string().required('Campo obrigatório.')}
          /> </>}
        <FormInput
          label="Fornecedor"
          name="fornecedor"
          id='mrn-input-fornecedor'
          value={contrato.numeroFornecedor}
          disabled span={2} />
        <FormInput
          label=" "
          name="fornecedorNome"
          id='mrn-input-fornecedorNome'
          value={contrato.nomeFornecedor} disabled span={4} />
      </Row>

      {tipoContrato === 'contrato' ? (
        <Row>
          <FormInput
            label="Diretoria"
            name="diretoriaTexto"
            id='mrn-input-diretoriaTexto'
            value={contrato.diretoria} disabled span={4} />
          <FormInput
            label="Área"
            name="areaTexto"
            id='mrn-input-areaTexto'
            value={contrato.area} disabled span={4} />
          <FormInput
            label="Departamento"
            name="departamentoTexto"
            id='mrn-input-departamentoTexto'
            value={contrato.departamento} disabled span={4} />
        </Row>
      ) : (
        <Row>
          <FormInput
            label="Diretoria"
            name="diretoriaTexto"
            id='mrn-input-diretoriaTexto'
            disabled span={4} />
          <FormInput
            label="Área"
            name="areaTexto"
            id='mrn-input-areaTexto'
            disabled span={4} />
          <FormInput
            label="Departamento"
            name="departamentoTexto"
            id='mrn-input-departamentoTexto'
            disabled span={4} />
        </Row>
      )}

      <Row>
        <FormTextArea
          id="mrn-textarea-objetoASerContratado"
          name="objeto"
          label="Objeto a Ser Contratado"
          span={12}
          rows={1}
          disabled={statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante}
          validateSchema={Yup.string().trim().required('Campo requerido')}
          maxLength={4000}
        />
      </Row>
      <Row>
        <FormTextArea
          id="mrn-textarea-justificativaRequisicaoCompra"
          label="Justificativa da Contratação"
          name="justificativaRequisicaoCompra"
          span={6}
          rows={1}
          validateSchema={Yup.string().trim().required('Campo requerido')}
          disabled={statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante}
        />
        <FormInput
          id="mrn-input-localDeExecucao"
          label="Local de Execução"
          name="localDeExecucao"
          span={6}
          validateSchema={Yup.string().trim().required('Campo requerido')}
          disabled={statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante}
        />
      </Row>

      <Row>
        <Col span={6}>
          <Row style={{ display: 'grid' }}>
            <div style={{ marginBottom: '3px' }}>
              <label>Característica Contratação</label>
              <Tooltip title={'Contratações de representantes comerciais, serviços jurídicos, de consultorias, consórcios, serviços de despachantes, segurança privada e leiloes de madeiras devem passar pela avaliação de Due Diligence de Integridade conforme PAD DP.PAD.0005.'}>
                <Icon name={'commons-info'} style={{ fontSize: 14 }} />
              </Tooltip>
            </div>
            <FormSelect
              value={caracteristicaContratacao}
              onSelect={(e: string) => setCaracteristicaContratacao(e)}
              id='mrn-select-caracteristicaContratacao'
              getOptions={caracteristicaContratacaoOptions}
              //label="Característica Contratação"
              name="caracteristicaContratacao"
              //span={4}
              required
            />
          </Row>
        </Col>
        <Col span={6}>
          <Row style={{ display: 'grid' }}>
            <div style={{ marginBottom: '3px' }}>
              <label>Relacionamento com Entidade Pública?</label>
              <Tooltip title={'Toda e qualquer tipo de aquisição ou contratação de serviços que envolva entidades ou agentes públicos, ONGs e fundações sem fins lucrativos.'}>
                <Icon name={'commons-info'} style={{ fontSize: 14 }} />
              </Tooltip>
            </div>
            <FormSelect
              id='mrn-select-relacionamentoEntidadePublica'
              options={optionsSwitch}
              //label="Relacionamento com Entidade Pública?"
              name="relacionamentoEntidadePublica"
              //span={4}
              required
            />
          </Row>
        </Col>
      </Row>

      <Visibility
        visible={usuarioAdmContrato}
      >
        <Row>
          <FormSelect
            label="Gestor Técnico"
            name="gestorTecnicoId"
            id='mrn-select-gestorTecnico'
            getOptions={getAllGestoresOptions}
            value={gestorTecnicoId}
            disabled={disableGestor}
            span={4}
            showSearch
            onSelect={(e: string) => setGestorTecnicoId(e)}
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
            }}
            required={!disableGestor}
            validationSchema={Yup.string().required('Campo obrigatório.')}
          />
        </Row>
      </Visibility>

    </>
  );
}

export default IdentificacaoAdtivo;
